import { useEffect } from "react";
import dataProvider from "server/dataProvider";

// Loads the options of one pre-filter field (a GET `request`) into `setChoices` while `enabled`, otherwise empties
// them. A late response of a stale request is dropped (`ignore`), so quick re-selection can't put the wrong options
// back. Options feed a value the user is picking, so a failure is shown (`errorText`).
const useChoices = (enabled, request, setChoices, errorText, notify) => {
  useEffect(() => {
    if (!enabled) {
      setChoices([]);
      return undefined;
    }
    let ignore = false;
    dataProvider
      .customRequest(request, null, "GET")
      .then(res => !ignore && setChoices(res.data ?? []))
      .catch(() => !ignore && notify(errorText, { type: "error" }));
    return () => {
      ignore = true;
    };
  }, [enabled, request, setChoices, errorText, notify]);
};

export default useChoices;
